'use client';

import a__default from "react";
import { Text } from "../../Text/Text.js";
function renderPrefix({ icon: IconComponent, iconStyle, iconPosition, prefix }, disabled) {
  if (IconComponent && iconPosition === "lead") {
    return /* @__PURE__ */ a__default.createElement(
      IconComponent,
      {
        color: disabled ? "onLight.disabled.muted" : "onLight.icon.secondary",
        filled: iconStyle === "filled",
        size: "md"
      }
    );
  }
  if (prefix)
    return /* @__PURE__ */ a__default.createElement(
      Text,
      {
        "aria-hidden": "true",
        color: disabled ? "onLight.disabled.muted" : "onLight.text.tertiary"
      },
      prefix
    );
  return null;
}
export {
  renderPrefix
};
